const Locale = 'en-US';
const Currency = 'USD';

const convertNum = (num) => {
    if (!num) return 0;
    return num;
}

class Formatter {
    money(num, includeCents = false, showNull = false) {
        if (num === null && !showNull) {
            return ""
        }
        num = convertNum(num)
        return this.generateMoneyFormatter(includeCents).format(num)
    }

    percent(num, fractionDigits=2, showNull = false) {
        if (num === null && !showNull) {
            return ""
        }
        num = convertNum(num)
        return `${(num * 100).toFixed(fractionDigits)}%`
    }

    float(num, fractionDigits=3, showNull = false) {
        if (num === null && !showNull) {
            return ""
        }
        num = convertNum(num)
        return this.generateNumberFormatter(fractionDigits).format(num)
    }

    generateMoneyFormatter(includeCents=false) {
        const digits = includeCents ? 2 : 0;
        return new Intl.NumberFormat(Locale, {
            style: 'currency',
            currency: Currency,
            minimumFractionDigits: digits,
            maximumFractionDigits: digits,
        });
    }

    generateNumberFormatter(decPlaces=3) {
        return new Intl.NumberFormat(Locale, {
            style: 'decimal',
            minimumFractionDigits: decPlaces,
            maximumFractionDigits: decPlaces,
        });
    }

    cusip(cusip) {
        cusip = cusip.trim().toUpperCase();
        if (cusip.length === 8) cusip += getCusipWithChecksum(cusip);
        return cusip;
    }
}

/**
 * Given an 8-digit CUSIP, returns the 9-digit CUSIP. This is possible because
 * the last digit of a CUSIP is a checksum.
 */
export function getCusipWithChecksum(cusip8) {
    if (cusip8.length !== 8) {
        throw new Error("CUSIP must be 8 characters long (excluding checksum).");
    }

    const charToValue = (char) => {
        if (/[0-9]/.test(char)) return parseInt(char, 10);
        if (/[A-Z]/.test(char)) return char.charCodeAt(0) - 'A'.charCodeAt(0) + 10;
        if (char === '*') return 36;
        if (char === '@') return 37;
        if (char === '#') return 38;
        throw new Error(`Invalid CUSIP character: ${char}`);
    };

    const digits = cusip8.split('').map(charToValue);

    const transformed = digits.map((num, idx) => {
    const product = idx % 2 === 0 ? num * 1 : num * 2;
        return product > 9 ? Math.floor(product / 10) + (product % 10) : product;
    });

    const sum = transformed.reduce((acc, val) => acc + val, 0);
    const checksum = (10 - (sum % 10)) % 10;

    return checksum.toString();
}

const formatter = new Formatter()

export default formatter
